import styled from "styled-components";

export const StyledLoginCTA = styled.p`

    font-size: 12px;
    font-weight: 600;
    color: var(--color-grey-1);
    text-align: center;
`